module.exports = __webpack_public_path__ + "8e47f12ec6b732b514aec720f000907e.svg";